<div *ngIf="this.auth.isBusy" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60">
  <div class="h-10 w-10 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
</div>

<div [ngStyle]="environment.theme.background" class="min-h-screen bg-[var(--primary-dark)] flex items-center justify-center p-3 md:p-4">
  <div class="w-full max-w-md bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.15)] overflow-hidden">

    <div class="flex justify-center py-8 bg-[var(--background-registration)]">
      <img class="max-h-28 object-contain" [ngStyle]="environment.theme.logoStyling" [src]="environment.theme.logo" alt="Logo">
    </div>

    <div class="px-5 py-6 md:px-8 md:py-8 text-center">
      <p class="text-[var(--base-text-alt-dark)] text-[15px] font-semibold mt-2 mb-8" data-cy="welcome-title">{{environment?.theme?.welcomeTitle}}</p>

      <div class="flex flex-col gap-3 max-w-[240px] mx-auto">
        <button class="w-full border border-[var(--primary-dark)] text-[var(--primary-dark)] bg-white font-semibold py-2.5 rounded-lg text-[13px] cursor-pointer"
          type="submit" (click)="register()" data-cy="register-button">Register</button>
        <button class="w-full bg-[var(--primary-dark)] text-white font-semibold py-2.5 rounded-lg text-[13px] cursor-pointer border-none"
          type="submit" (click)="login()" data-cy="login-button">Login</button>
      </div>

      <div class="mt-8 text-[11px] text-[var(--base-text-alt-dark)]">
        <a [href]="termsAndConditionsUrl" target="_blank" class="font-semibold cursor-pointer underline" data-cy="terms-conditions-link">Terms & Conditions</a>
        <span class="mx-2">|</span>
        <a [href]="privacyPolicyUrl" target="_blank" class="font-semibold cursor-pointer underline" data-cy="privacy-policy-link">Privacy Policy</a>
      </div>

      <a [href]="publicFacingUrl" target="_blank" class="flex items-center justify-center gap-2 mt-4 text-[var(--base-text-alt-dark)] text-[12px] font-semibold no-underline" data-cy="back-to-website-link">
        <span class="material-icons text-[18px]">keyboard_backspace</span>
        <span data-cy="back-to-website-text">Back to Website</span>
      </a>
    </div>
  </div>
</div>
